/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M.25 6C.25 2.8244 2.8244.25 6 .25h12c3.1756 0 5.75 2.5744 5.75 5.75v9c0 3.1756-2.5744 5.75-5.75 5.75h-3.2677a1.762 1.762 0 0 1 .0177.25v1c0 .0849-.006.1683-.0177.25H17.5a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1 0-1.5h2.7677A1.765 1.765 0 0 1 9.25 22v-1c0-.0849.006-.1683.0177-.25H6C2.8244 20.75.25 18.1756.25 15V6ZM13 22.25a.25.25 0 0 0 .25-.25v-1a.25.25 0 0 0-.25-.25h-2a.25.25 0 0 0-.25.25v1a.25.25 0 0 0 .25.25h2Zm5-3H6c-2.3472 0-4.25-1.9028-4.25-4.25V6c0-2.3472 1.9028-4.25 4.25-4.25h12c2.3472 0 4.25 1.9028 4.25 4.25v9c0 2.3472-1.9028 4.25-4.25 4.25Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.5921 9.5842c.9668-.2638 1.7283-1.0253 1.9921-1.992h1.2104L12 9.7974l2.2054-2.2054h1.2104c.2638.9668 1.0253 1.7283 1.9921 1.9921v6.2579a.75.75 0 0 0 1.5 0V9.5842C20.1136 9.2552 21 8.1522 21 6.8422 21 5.2724 19.7275 4 18.1579 4c-1.3101 0-2.4131.8864-2.7421 2.0921h-1.8317L12 7.6761l-1.5841-1.584H8.5842C8.2552 4.8864 7.1522 4 5.8422 4 4.2724 4 3 5.2725 3 6.8421c0 1.31.8864 2.413 2.0921 2.7421v6.2579a.75.75 0 0 0 1.5 0V9.5842Zm.5921-2.742c0 .7411-.6009 1.342-1.342 1.342-.7413 0-1.3422-.6009-1.3422-1.342C4.5 6.1008 5.1009 5.5 5.8421 5.5c.7412 0 1.3421.6009 1.3421 1.3421Zm12.3158 0c0 .7411-.6009 1.342-1.3421 1.342-.7412 0-1.3421-.6009-1.3421-1.342 0-.7413.6009-1.3422 1.3421-1.3422.7412 0 1.3421.6009 1.3421 1.3421Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12.75 12.5263a.75.75 0 0 0-1.5 0v2.8421a.75.75 0 0 0 1.5 0v-2.8421Z"
    />
  </React.Fragment>,
  'MenuMoesifDashboard'
);
